export const FINISHED_FETCHING_AUTHENTICATED_USER_INFO_FROM_BACKEND = 'FINISHED_FETCHING_AUTHENTICATED_USER_INFO_FROM_BACKEND'
export const STARTED_UPDATING_USER = 'STARTED_UPDATING_USER'
export const FINISHED_UPDATING_USER = 'FINISHED_UPDATING_USER'